// // import { JourneyStudent, JourneyInstructor } from "../types/journey.types";
// import { JourneyStudent,JourneyInstructor } from "../Journey/journey.types";
// export const createEmptyStudent = (): JourneyStudent => ({
//   name: "",
//   email: "",
//   studentClasses: "",
//   attendance: "Present",
// });

// export const createEmptyInstructor = (): JourneyInstructor => ({
//   name: "",
//   email: "",
//   instructorClasses: "",
//   attendance: "Present",
// });

// import {
//   JourneyStudent,
//   JourneyInstructor,
// } from "../components/Journey/journey.types";
 import { JourneyStudent,JourneyInstructor } from "../Journey/journey.types";

/**
 * Create an empty student object with default values
 */
export const createEmptyStudent = (): JourneyStudent => ({
  name: "",
  email: "",
  studentClasses: "",
  attendance: "Present",
  studentStatus: "Active",
});

/**
 * Create an empty instructor object with default values
 */
export const createEmptyInstructor = (): JourneyInstructor => ({
  name: "",
  email: "",
  instructorClasses: "",
  attendance: "Present",
});